import { NOTIFICATION_CATEGORIES } from "constant/variables";
import { Activity } from "react-feather";

import {
  Target,
  UserCheck,
  Globe,
  ShoppingBag,
  FileMinus,
  Home,
  FilePlus,
  Layout,
  List,
  Users,
  Feather,
  Disc,
  Layers,
  Bell,
  Sliders,
  FileText,
  HelpCircle,
  AlignLeft,
  BarChart2,
} from "react-feather";
import { USER_NOTIFICATION_ROUTES } from "route";

export const COMMAN_MENUITEMS = [
  // Conditionally include "My Performance" only if NOT admin

  {
    Items: [
      {
        title: "My Performance",
        icon: UserCheck,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/myPerformance`,
      },
    ],
  },

  {
    Items: [
      {
        title: "Staff Performance",
        icon: Users,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/staffPerformance`,
      },
    ],
  },
  {
    Items: [
      {
        title: "CVM",
        icon: Activity,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/cvm`,
      },
    ],
  },
  {
    Items: [
      {
        title: "System Usage Report",
        icon: Sliders,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/system-usage-report`,
      },
    ],
  },
];

export const FOOTER_MENUITEMS = [
  {
    Items: [
      {
        title: "Latest offer",
        icon: Feather,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/${
          USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.OFFER]
        }`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Notification",
        icon: Disc,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/${
          USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.NOTIFICATION]
        }`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Training & Learning",
        icon: Layers,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/${
          USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.TRAINING]
        }`,
      },
    ],
  },

  {
    Items: [
      {
        title: "Quiz & Survey",
        icon: FileText,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/${
          USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.QUIZ]
        }`,
      },
    ],
  },
];

export const AGENT_MENUITEMS = [
  {
    Items: [
      {
        title: "My Performance",
        icon: UserCheck,
        type: "link",
        active: true,
        path: `${process.env.PUBLIC_URL}/myPerformance`,
      },
    ],
  },
];

export const ADMIN_MENUS = [
  {
    Items: [
      {
        title: "Training Report",
        icon: BarChart2,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/${
          USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.TRAINING_REPORT]
        }`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Upload Notifications",
        icon: Bell,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/notifications`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Import Sales",
        icon: FilePlus,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/importSales`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Manage Region",
        icon: Globe,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/manageregion`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Manage Outlet",
        icon: Layout,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/manageoutlet`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Manage Product",
        icon: ShoppingBag,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/manageproduct`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Manage Plans",
        icon: FileMinus,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/manageplans`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Manage Target",
        icon: Target,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/managetarget`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Scale Management",
        icon: List,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/scalemanagement`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Create Quiz",
        icon: HelpCircle,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/create-quiz`,
      },
    ],
  },
  {
    Items: [
      {
        title: "Create Survey",
        icon: AlignLeft,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/create-survey`,
      },
    ],
  },
];
